export default {
  'transfer_modal.max': 'Max',
  'transfer_success': 'Transfer successful',
  'Bonus Voucher': 'Bonus Voucher',
  'transfer_bonus_tip': 'The balance of your Futures Bonus Voucher is {num} USDT. Please note that when you transfer assets out of your Futures account, all Bonus Vouchers will be recovered and all positions will be liquidated.'
};
